// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'User roles configuration'"></sub-header>
  <div class="info" ng-if="\$ctrl.role">
      <div class="info__field">
        <span class="info__field-label">Role:</span>
        <span class="info__field-value">{{\$ctrl.role.name}}</span>
      </div>
  </div>
<div class="tab-menu">
  <ul class="nav-tabs">
    <li class="active"><a id="tab_link_read" data-target="#tab_read_access" data-toggle="tab">
      <span>Read access</span>
    </a></li>
    <li><a data-target="#tab_write_access" data-toggle="tab">
      <span>Write access</span>
    </a></li>
  </ul>
</div>

<div class="tab-content" style="overflow: unset">

  <div class="tab-pane active" id="tab_read_access">
    <div>
      <form name="\$ctrl.permissionForm">
        <role-read-access role="\$ctrl.role"
                          role-permissions="\$ctrl.rolePermissions">
        </role-read-access>
        <div class="btn-toolbar pull-right">
          <button class="btn btn-primary"
                  command-access="UpdateRolePermissions"
                  ng-click="\$ctrl.save()">
            Save
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="tab-pane" id="tab_write_access">
    <div>
      <role-write-access-list role="\$ctrl.role">
      </role-write-access-list>
    </div>
  </div>
</div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/security/roles-config.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;